import React from 'react';
import { ColorPicker } from '@atlassian/jira-color-picker';
import { asColor } from '@atlassian/jira-issue-epic-color';
import { withFormField } from '../../common/ui';
import type { Props, ColorPickerFieldConfig, FieldValue } from './types';

const ColorPickerField = (props: Props) => {
	const {
		fieldProps: { value, onChange },
	} = props;

	return <ColorPicker value={value} onChange={onChange} showColorName />;
};

export default withFormField({ transformDefaultValue: asColor })<
	ColorPickerFieldConfig,
	FieldValue
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<ColorPickerFieldConfig, Color>, any>'.
>(ColorPickerField);
export { mutateEpicColorField, mutateIssueColorField } from './utils';
